import { KeyValue } from "@/common/components/key-value";
import { H3 } from "@/common/elements";
import { KeyValueObj } from "@/common/types";
import styled from "styled-components";

const RecallContainer = styled.div`
  .double-column-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-top: 1rem;
    margin-bottom: 4rem;
  }
`;

const RecallProductDetails = (data: KeyValueObj) => {
  return (
    <RecallContainer>
      <H3>Product Details</H3>
      <div className="double-column-wrapper">
        {data?.data?.map((detail: KeyValueObj, i: number) => (
          <KeyValue key={i} title={detail?.title} value={detail?.value} />
        ))}
      </div>
    </RecallContainer>
  );
};

export default RecallProductDetails;
